import { object, string } from 'yup';

export const getSchemaStep = (t, allSteps, currentStepId) => object().shape({
  type_step: string()
    .required(t('funnelStepSidebar.typeStep.required'))
    .oneOf(['step', 'won', 'lost'], t('funnelStepSidebar.typeStep.invalid')),
  title: string()
    .required(t('funnelStepSidebar.required'))
    .max(40, t('funnelStepSidebar.name.max'))
    .test(
      'unique-title',
      t('sidebar.createFromZero.errors.nameExists'),
      function (value) {
        if (!value) return true;
        return !allSteps.some(
          (step) =>
            (step.title === value || step.name === value) &&
            step.id !== currentStepId
        );
      }
    ),
  stagnation_time: string()
    .nullable()
    .max(10, t('funnelStepSidebar.time.max'))
    .test(
      'is-number',
      t('funnelStepSidebar.time.number'),
      value => {
        if (value === null || value === undefined) return true;
        if (value === '') return false;
        return !isNaN(Number(value));
      }
    )
    .when('stagnationTimeEnabled', {
      is: true,
      then: schema =>
        schema
          .min(1, t('funnelStepSidebar.time.min'))
          .required(t('funnelStepSidebar.time.required')),
      otherwise: schema => schema.notRequired(),
    }),
});
